<template>
    <div class="login-container" v-loading.fullscreen.lock="!login" element-loading-text="logining" element-loading-background="rgba(0, 0, 0, 0.8)">
        <!-- <zm-form class="login-form" autoComplete="on" :model="loginForm" ref="loginForm" label-position="left" label-width="90px"> -->
            <!-- <zm-form-item>
                <span class="title-login">AWS Access</span>
            </zm-form-item>
            <zm-form-item prop="accessKey">
                <zm-input size="small" name="accessKey" type="text" v-model="loginForm.accessKey" autoComplete="on" placeholder="accessKey" />
            </zm-form-item>
            <zm-form-item prop="secretKey">
                <zm-input size="small" name="secretKey" type="password" @keyup.enter.native="handleLogin" v-model="loginForm.secretKey"
                    autoComplete="on" placeholder="secretKey"></zm-input>
            </zm-form-item>
            <zm-form-item>
                <zm-select v-model="loginForm.namespace" class="login-select" placeholder="namespace" @change="fetchApplication" filterable popper-class="select-popper">
                    <zm-option v-for="item in namespaceList" :key="item" :value="item"></zm-option>
                </zm-select>
            </zm-form-item>
            <zm-form-item>
                <zm-select v-model="loginForm.application" class="login-select" placeholder="application" filterable popper-class="select-popper">
                    <zm-option v-for="item in applicationList" :key="item.id" :label="item.applicationName" :value="item.id"></zm-option>
                </zm-select>
            </zm-form-item> -->
            <!-- <zm-form-item>
                <zm-button size="small" type="primary" style="width:100%;" @click.native.prevent="handleLogin" :loading="!login">Enter
                </zm-button>
            </zm-form-item>
        </zm-form> -->
    </div>
</template>
<script>
import { awsLogin, accessToken, listNamespace, listApplication } from '@/api/index'
import { getMenuList } from '@/api/permission'
export default {
    name: 'login',
    data () {
        return {
            login: false,
            loading: false,
            namespaceList: [],
            applicationList: [],
            loginForm: {
                accessKey: '',
                secretKey: '',
                namespace: '',
                application: ''
            }
        }
    },
    created () {
        if (this.$route.query.token) {
            var token = this.$route.query.token
            accessToken(token).then(response => {
                localStorage.setItem('email', response.email)
                localStorage.setItem('token', response.accessToken)
                localStorage.setItem('redirectUrl', response.redirectUrl)
                localStorage.setItem('saferDisplay', response.saferDisplay)
                this.login = true
                getMenuList().then(response => {
                localStorage.permission = response.data.map(item => {
                    return 'menu-' + item
                })
                const path = localStorage.path
                const params = localStorage.params
                console.log(localStorage.params)
                if (path) {
                    this.$router.push({
                        path,
                        query: { params }
                    })
                } else {
                this.$router.push('/')
                }
                })
                // this.fetchNamespace()
            })
        }
    },
    methods: {
        fetchNamespace () {
            listNamespace().then(response => {
                localStorage.setItem('namespaceList', JSON.stringify(response))
                this.namespaceList = response
            })
        },
        fetchApplication () {
            listApplication(this.loginForm.namespace).then(response => {
                this.applicationList = response.data
            })
        },
        handleLogin () {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.loading = true
                    console.log(this.loginForm)
                    awsLogin(this.loginForm).then(response => {
                        this.loading = false
                        this.loading = false
                        localStorage.setItem('namespace', this.loginForm.namespace)
                        localStorage.setItem('application', this.loginForm.application)
                        localStorage.setItem('accessKey', this.loginForm.accessKey)
                        this.$router.push('/')
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        }
    }
}
</script>
<style scoped>
.login-select {
  width: 100%;
  text-align: left;
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.title-login {
  font-size: 24px;
}
$bg:#363a40;
$dark_gray:#889aa4;
$light_gray:#eee;
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: $bg;
  text-align: center;
  color: #b4b4b4;
  .login-form {
    position: absolute;
    left: 0;
    right: 0;
    width: 420px;
    padding: 35px 35px 15px 35px;
    margin: calc((100vh - 300px) / 2) auto;
  }
  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
    &_login {
      font-size: 20px;
    }
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    color: $light_gray;
    margin: 0px auto 40px auto;
    text-align: center;
    font-weight: bold;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
.radio-label {
  color: #b4b4b4;
}
</style>
